// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./scss/main.scss
// module id = 19
// module chunks = 0